(function(module) {
    'use strict';

    function EditPlaylistCtrl(
        $timeout,
        $scope,
        $state,
        $stateParams,
        Includes,
        App,
        Store,
        Playlist,
        $mdDialog,
        AppStylesInPlaylist,
        Group,
        Display,
        utils,
        playlistSavePayload,
    ) {
        this.setDefault = () => {
            this.mode = $stateParams.route;
            this.playlistId = $stateParams.id;
            this.checked = false;
            this.selectedIndex = 0;
            this.selectedApps = [];
            this.appPreview = false;
            this.orientation = 'landscape';
            this.selectedAll = false;
            this.flex1 = 50;
            this.flex2 = 50;
            this.changeArrow = false;
        };

        this.getData = () => {
            if (this.mode === 'edit') {
                Promise.all([this.findPlaylist(this.playlistId), this.getApps()])
                    .then(([playlist, apps]) => {
                        this.loading = false;

                        //PLAYLIST
                        this.playlist = Store.setSingleModelData('playlists', playlist.id, playlist);

                        this.selectedApps = this.playlist.apps;

                        //SELECTED MD TAB
                        if (this.playlist.type === 'basic') {
                            this.selectedIndex = 0;
                        }
                        if (this.playlist.type === 'advanced') {
                            this.selectedIndex = 1;
                        }

                        //APPS
                        this.apps = Store.setMultiModelData('apps', apps);
                        this.selectedApps = AppStylesInPlaylist.getAppStylesInPlaylist(this.playlist.apps, apps);

                        // set preview app
                        const appId = _.get(this, 'playlist.apps[0].id');
                        if (appId) {
                            const app = Store.getSingleModelData('apps', appId);

                            this.selectedApps.forEach((selectedApp) => {
                                if (selectedApp.id === appId) {
                                    selectedApp.active = true;
                                }
                            });

                            this.selectPreviewApp(app, app.appTemplate);
                        } else {
                            this.disablePreview = true;
                        }
                    })
                    .catch((error) => {
                        console.log({ error });
                        this.loading = false;
                    });
            }

            if (this.mode === 'add') {
                this.getApps().then((apps) => {
                    this.apps = Store.setMultiModelData('apps', apps);
                });
            }

            const appDuration = ({ duration = {} }) => {
                const h = duration.hrs || 0;
                const m = duration.mins || 0;
                const s = duration.secs || 0;
                return h * 3600 + m * 60 + s;
            };

            // Calculate the total which is used for validation
            $scope.$watch(
                '$ctrl.selectedApps',
                (newValues) => {
                    newValues.forEach((app, i) => {
                        const total = appDuration(app);
                        if (app.totalDuration !== total) {
                            app.totalDuration = total;
                        }
                    });
                },
                true,
            );
        };

        this.$onInit = () => {
            this.setDefault();
            this.getData();
        };

        this.onSubAccountChange = () => {
            this.$onDestroy();
            this.setDefault();
            this.getData();
        };

        this.$onDestroy = () => {
        };
        this.collapse = () => {
            if (this.flex1 === 50) {
                this.changeArrow = true;
                this.flex1 = 30;
                this.flex2 = 70;
            } else {
                this.changeArrow = false;
                this.flex1 = 50;
                this.flex2 = 50;
            }
        };

        this.getApps = () => {
            return App.find({ filter: Includes.apps }).$promise;
        };

        this.findPlaylist = (playlistId) => {
            return Playlist.findById({ id: playlistId }).$promise.then(playlist => {
                return utils.handlePermissions(playlist);
            });
        };

        this.droppedFile = () => {
            this.form.$setDirty();
        };

        this.deleteById = ({ id }) => {
            return Playlist.removeById({ id })
                .$promise.then(() => {
                    return Store.removeSingleModelData('playlists', id);
                })
                .then(() => {
                    $state.go('root.playlists');
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });
        };

        this.revert = () => {
            this.form.$setPristine();
            this.setDefault();
            this.getData();
        };

        this.addAppToPlaylist = ({ id, name, appTemplate }) => {
            const app = {
                id,
                name,
                styles: appTemplate.styles,
                total: 0,
                slug: appTemplate.slug,
                duration: {
                    hrs: 0,
                    mins: 0,
                    secs: 0,
                },
            };
            this.selectedApps.push(app);
            this.form.$setDirty();
        };

        this.deleteItem = (deletedApp, index) => {
            this.selectedApps.splice(index, 1);
            this.form.$setDirty();

            this.apps.forEach((app) => {
                if (app.id === deletedApp.id) {
                    app.checked = false;
                }
            });
            if (!this.selectedApps.length) {
                this.appPreview = false;
            }
        };
        let totalDuration = 0;

        this.setDuration = () => {
            if (this.selectedApps && this.selectedApps.length) {
                this.selectedApps.forEach((appInPlaylist) => {
                    if (appInPlaylist.duration) {
                        const hours = appInPlaylist.duration.hrs || 0;
                        const minutes = appInPlaylist.duration.mins || 0;
                        const seconds = appInPlaylist.duration.secs || 0;
                        appInPlaylist.duration.mins = minutes;
                        appInPlaylist.duration.hrs = hours;
                        appInPlaylist.duration.secs = seconds;

                        totalDuration = totalDuration + (hours * 3600 + minutes * 60 + seconds);
                    }
                });
                return totalDuration;
            }
        };
        this.checkAppsOrder = () => {
            let result = true;
            for (let i = 0; i < this.selectedApps.length; i++) {
                if (i + 1 < this.selectedApps.length && this.selectedApps[i].id === this.selectedApps[i + 1].id) {
                    result = false;
                    break;
                }
            }
            return result;
        };
        this.showError = false;
        this.save = () => {
            this.setDuration();
            if (this.checkAppsOrder()) {
                this.showError = false;

                if (!this.playlist.id) {
                    //add
                    Playlist.create(playlistSavePayload.buildCreatePlaylistPayload(this.playlist, this.selectedApps, totalDuration))
                        .$promise.then((playlist) => {
                        $state.go('root.playlists.edit', { id: playlist.id });
                    })
                        .catch((error) => {
                            console.error(error);
                            Raven.captureException(error);
                        });
                } else {
                    Promise.all([
                        this.findDisplaysUsingPlaylistId(this.playlist.id),
                        this.findGroupsUsingPlaylistId(this.playlist.id),
                    ]).then(([displaysUsingPlaylistId, groupsUsingPlaylistId]) => {
                        let displaysUsingPlaylistIdCount = displaysUsingPlaylistId && displaysUsingPlaylistId.length;
                        let groupsUsingPlaylistIdCount = groupsUsingPlaylistId && groupsUsingPlaylistId.length;
                        let modalTitle;
                        let modalConfirmationText;
                        let modalCancelText;
                        let modalConfirmText;
                        let confirmActionFunc;
                        let itemCount1;
                        let itemCount2;
                        this.saveChanges = () => {
                            Playlist.prototype$patchAttributes(
                                { id: this.playlist.id },
                                playlistSavePayload.buildUpdatePlaylistPayload(this.playlist, this.selectedApps, totalDuration),
                            )
                                .$promise.then(() => {
                                this.form.$setPristine();
                            })
                                .catch((error) => {
                                    console.error(error);
                                    Raven.captureException(error);
                                });
                        };

                        if (displaysUsingPlaylistIdCount > 0 || groupsUsingPlaylistIdCount > 0) {
                            modalTitle = 'Any changes made now to this playlist wil be also applied to:';
                            itemCount1 = displaysUsingPlaylistIdCount > 0 ? `${displaysUsingPlaylistIdCount + ' of your displays'}` : null;
                            itemCount2 = groupsUsingPlaylistIdCount > 0 ? `${groupsUsingPlaylistIdCount + ' of your groups'}` : null;
                            modalConfirmationText = 'as the playlist is being used by the above.';
                            modalConfirmText = 'Apply changes';
                            modalCancelText = 'Cancel';
                            const modalTypeOverride = 'information';

                            confirmActionFunc = () => {
                                this.saveChanges();
                            };
                            $mdDialog.show({
                                locals: {
                                    title: modalTitle,
                                    confirmationText: modalConfirmationText,
                                    cancelText: modalCancelText,
                                    confirmText: modalConfirmText,
                                    itemCount1: itemCount1,
                                    itemCount2: itemCount2,
                                    modalTypeOverride: modalTypeOverride,
                                },
                                controller: ($scope, $mdDialog) => {
                                    $scope.cancel = () => {
                                        $mdDialog.hide();
                                    };
                                    $scope.confirm = () => {
                                        $scope.cancel();
                                        confirmActionFunc();
                                    };
                                },
                                controllerAs: '$ctrl',
                                bindToController: true,
                                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                                parent: angular.element('body'),
                                clickOutsideToClose: true,
                                escapeToClose: true,
                            });
                        } else {
                            this.saveChanges();
                        }
                    });
                }
            } else {
                this.showError = true;
            }
        };
        this.findDisplaysUsingPlaylistId = (playlistId) => {
            return Display.find({
                filter: {
                    where: { playlistId },
                    fields: ['id'],
                },
            }).$promise;
        };
        this.findGroupsUsingPlaylistId = (playlistId) => {
            return Group.find({
                filter: {
                    where: { playlistId },
                    fields: ['id'],
                },
            }).$promise;
        };
        this.openDialog = (
            modalTitle,
            modalConfirmationText,
            modalCancelText,
            modalConfirmText,
            confirmActionFunc,
            itemCount1,
            itemCount2,
            id,
        ) => {
            $mdDialog.show({
                locals: {
                    title: modalTitle,
                    confirmationText: modalConfirmationText,
                    cancelText: modalCancelText,
                    confirmText: modalConfirmText,
                    itemCount1: itemCount1,
                    itemCount2: itemCount2,
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        $scope.cancel();
                        confirmActionFunc(id);
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };

        this.delete = (id) => {
            //find displays using playlist
            //find groups using playlist

            Promise.all([this.findDisplaysUsingPlaylistId(id), this.findGroupsUsingPlaylistId(id)]).then(
                ([displaysUsingPlaylistId, groupsUsingPlaylistId]) => {
                    let displaysUsingPlaylistIdCount = displaysUsingPlaylistId && displaysUsingPlaylistId.length;
                    let groupsUsingPlaylistIdCount = groupsUsingPlaylistId && groupsUsingPlaylistId.length;
                    let modalTitle;
                    let modalConfirmationText;
                    let modalCancelText;
                    let modalConfirmText;
                    let confirmActionFunc;
                    let itemCount1;
                    let itemCount2;

                    if (displaysUsingPlaylistIdCount <= 0 && groupsUsingPlaylistIdCount <= 0) {
                        modalTitle = 'Are you sure you want to permanently remove this playlist?';
                        modalConfirmText = 'Yes, remove';
                        modalCancelText = 'Cancel';
                        confirmActionFunc = (id) => {
                            this.deleteById({ id });
                        };
                    } else {
                        modalTitle = 'You can\'t delete this playlist as being used by :';

                        itemCount1 = displaysUsingPlaylistIdCount > 0 ? `${displaysUsingPlaylistIdCount + ' of your displays'}` : null;
                        itemCount2 = groupsUsingPlaylistIdCount > 0 ? `${groupsUsingPlaylistIdCount + ' of your groups'}` : null;

                        modalConfirmationText = 'Please make sure the playlist is not being used before deleting.';
                        modalCancelText = 'Ok, I understand';
                    }
                    this.openDialog(
                        modalTitle,
                        modalConfirmationText,
                        modalCancelText,
                        modalConfirmText,
                        confirmActionFunc,
                        itemCount1,
                        itemCount2,
                        id,
                    );
                },
            );
        };
        this.onPlaylistAppClicked = (appId) => {
            this.disablePreview = false;
            const app = Store.getSingleModelData('apps', appId);
            this.selectPreviewApp(app, app.appTemplate);
        };
        this.selectPreviewApp = (app, appTemplate) => {
            this.disablePreview = false;
            this.app = app;
            this.appTemplate = appTemplate;
            this.selectedApps.forEach((selectedApp) => {
                if (selectedApp.id === this.app.id) {
                    selectedApp.active = true;
                } else {
                    selectedApp.active = false;
                }
            });

            if (!$scope.$$phase) {
                $timeout(() => {
                    $scope.$apply();
                });
            }
        };
        this.pickMyApps = () => {
            this.appPreview = false;
        };
        this.showPreview = () => {
            this.appPreview = true;
            // reset preview to the first item in the playlist

            const appId = _.get(this, 'selectedApps[0].id');
            if (appId) {
                const app = Store.getSingleModelData('apps', appId);

                this.selectedApps.forEach((selectedApp, index) => {
                    if (selectedApp[index] === 0) {
                        selectedApp.active = true;
                    } else {
                        selectedApp.active = false;
                    }
                });

                this.selectPreviewApp(app, app.appTemplate);
            } else {
                this.disablePreview = true;
            }
        };

        this.clonePlaylist = (data) => {
            return Playlist.create(data).$promise;
        };

        this.getPlaylistById = (id) => {
            return Playlist.findById({ id: id, filter: Includes.playlists }).$promise;
        };

        this.clone = (id) => {
            const modalTitle = 'You are just about to clone the existing playlist';
            const modalConfirmationText =
                'Once cloned you will be taken to the new playlist view. Make sure you save your changes before cloning.';
            const modalCancelText = 'Cancel';
            const modalConfirmText = 'Clone';
            const modalTypeOverride = 'information';
            const confirmActionFunc = (id) => {
                this.getPlaylistById(id)
                    .then((playlistToClone) => {
                        if (!playlistToClone) {
                            return console.error('Error cloning playlist, cannot find playlist to clone');
                        }

                        const playlistToCreate = _.omit(playlistToClone, ['id']);
                        playlistToCreate.name = `${playlistToCreate.name} - copy`;
                        return this.clonePlaylist(playlistToCreate);
                    })
                    .then(({ id }) => {
                        return this.getPlaylistById(id);
                    })
                    .then((playlist) => {
                        return Store.setSingleModelData('playlists', playlist.id, playlist);
                    })
                    .then((playlist) => {
                        $state.go('root.playlists.edit', {
                            id: playlist.id,
                            playlistId: playlist.id,
                            playlist: playlist,
                        });
                    })
                    .catch((error) => {
                        console.error('Error cloning playlist, error from the API', error);
                    });
            };

            $mdDialog.show({
                locals: {
                    title: modalTitle,
                    confirmationText: modalConfirmationText,
                    cancelText: modalCancelText,
                    confirmText: modalConfirmText,
                    modalTypeOverride: modalTypeOverride,
                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        $scope.cancel();
                        confirmActionFunc(id);
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };
    }

    module
        .config(($stateProvider, $translatePartialLoaderProvider) => {
            $stateProvider
                .state('root.playlists.add', {
                    url: '/add',
                    data: {
                        pageTitle: 'PLAYLISTS.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<edit-playlist-component />',
                        },
                    },
                    params: {
                        route: { value: 'add' },
                    },
                    bodyClass: 'page--add-playlist',
                })
                .state('root.playlists.edit', {
                    url: '/:id',
                    data: {
                        pageTitle: 'PLAYLISTS.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<edit-playlist-component />',
                        },
                    },
                    params: {
                        route: { value: 'edit' },
                    },
                    bodyClass: 'page--edit-playlist',
                });

            // Translations
            $translatePartialLoaderProvider.addPart('/js/playlists');
        })
        .component('editPlaylistComponent', {
            templateUrl: '/js/playlists/edit-playlist/edit-playlist.html',
            controller: EditPlaylistCtrl,
        });
})(angular.module('rocket.components'));
